<template>
    <div class="indexBlackes home-box" id="sw">
     
      <div class="Dcontianer">
          <div class="bannerText">
            <h1>{{$t('NEW.title')}}</h1>
            <p>{{$t('NEW.title2')}}</p>
            <div>
              <router-link class="links" :to="{ name: 'login'}">
              <span>
                {{$t('NEW.l3')}}
              </span>
              </router-link>
            </div>
          </div>
          
          <div class="swiperContainer">

            <carousel  class="carousel" :perPageCustom="[[1110,4],[1110,4]]" :navigationEnabled="true" :loop="true" :autoplay="true" :pagination="true">
            <slide style="margin-right:20px" class=" item carouselImg" v-for="(item,index) in swiperImgs"  :key="index" >
              <img  :src="item.cover"  @click="goDetail(item.id)">
            </slide>
          </carousel>
             
          </div>
          <div class="gonggao">
              <img src="../assets/images/icon5.png" alt="" class="icon5">
              <div class="right">

                <carousel  class="carousel" :perPageCustom="[[1110,3],[1110,3]]"  :navigationEnabled="true" :loop="true" :autoplay="true" :pagination="true">
                <slide style="margin-right:20px" class=" item carouselImg"  v-for="(item,index) in  noticeList" :key="index"  >
              <div class="sun" @click="goDetail(item.id)" >
                       <h1>
                         <span>{{item.title}}</span>
                         <span>/</span>
                         </h1>
                         
                    </div>
                    
            </slide>
            
          </carousel>
              </div>
          </div>
      </div>
      <!-- 交易 -->
      <div class="container">
        <div class="transaction">
            <div class="top">
              <div  class="type" @click="changeTable(1)" :class="[ tableIndex == 1 ? 'titleActive':'']">
                <img style="border-radius: 50%;" src="../assets/images/icon11.jpg" alt="">
                <div class="cnTitle">{{$t('NEW.l4')}}</div>
              </div>
              <div class="type " @click="changeTable(2)" :class="[ tableIndex == 2 ? 'titleActive':'']">
                <img src="../assets/images/altcoin.png" alt="">
                <div class="cnTitle">{{$t('NEW.l5')}}</div>
              </div>
              <div class="type " @click="changeTable(3)" :class="[ tableIndex == 3 ? 'titleActive':'']">
                <img   style="border-radius: 50%;" src="../assets/images/icon12.gif" alt="">
                <div class="cnTitle">{{$t('NEW.l99')}}</div>
              </div>
            </div>
            <!-- table -->
            <!-- <div class="transactionTable">
              <div>市场</div>
              <div>币种</div>
              <div>最后成交价</div>
              <div>日变化量</div>
              <div>24小时最低价</div>
              <div>24小时最高价</div>
              <div>24小时成交量</div>
              <div>币种</div>
              <div>币种</div>
              <div>币种</div>
              <div>币种</div>
            </div> -->
            <table class="transactionTable">
               <thead>
                 <tr>
                   <th>&nbsp;</th>
                   <th>{{$t('NEW.l6')}}</th>
                   <th>{{$t('NEW.l7')}}</th>
                   <th>{{$t('NEW.l8')}}</th>
                   <th>{{$t('NEW.l9')}}</th>
                   <th>{{$t('NEW.l10')}}</th>
                   <th>{{$t('NEW.l11')}}</th>
                   <th>{{$t('NEW.l12')}}</th>
                 </tr>
               </thead>
               <tbody v-if="tableIndex == 0">
                <tr :class="[items.currency_name+'_'+items.legal_name]" :data-name='items.currency_name+"/"+items.legal_name'  v-for="(items,index) in  quotation" :key="index">
                   <th>&nbsp;</th>
                   <td >{{items.currency_name}}/{{items.legal_name}}</td>
                   <td>{{items.currency_name}}</td>
                   <td class="now_price">{{(items.now_price - 0).toFixed(4)}}</td>
                   <td class="baifen">{{Number(items.change).toFixed(2)|| '0.00'}}%</td>
                   <td class="max">0</td>
                   <td class="min">0</td>
                   <td class="volume1">{{(items.volume-0).toFixed(4)}}</td>
                </tr>
               </tbody>
               <tbody v-if="tableIndex == 1">
               <tr :class="[items.currency_name+'_'+items.legal_name]" :data-name='items.currency_name+"/"+items.legal_name'  v-for="(items,index) in  quotation2" :key="index"  v-if="items.is_display == 1&& index<6">
                   <th>&nbsp;</th>
                   <td>{{items.currency_name}}/{{items.legal_name}}</td>
                   <td>{{items.currency_name}}</td>
                   <td class="now_price">{{(items.now_price - 0).toFixed(4)}}</td>
                   <td class="baifen">{{Number(items.change).toFixed(2)|| '0.00'}}%</td>
                   <td class="max">0</td>
                   <td class="min">0</td>
                   <td class="volume1">{{(items.volume-0).toFixed(4)}}</td>
                </tr>
               </tbody>
               <tbody v-if="tableIndex == 2">
                <tr :class="[items.currency_name+'_'+items.legal_name]" :data-name='items.currency_name+"/"+items.legal_name'  v-for="(items,index) in  quotation3" :key="index"  v-if="items.is_display == 1&& index<6">
                   <th>&nbsp;</th>
                   <td>{{items.currency_name}}/{{items.legal_name}}</td>
                   <td>{{items.currency_name}}</td>
                   <td class="now_price">{{(items.now_price - 0).toFixed(4)}}</td>
                   <td class="baifen">{{Number(items.change).toFixed(2)|| '0.00'}}%</td>
                   <td class="max">0</td>
                   <td class="min">0</td>
                   <td class="volume1">{{(items.volume-0).toFixed(4)}}</td>
                </tr>
               </tbody>
               <tbody v-if="tableIndex == 3">
                <tr :class="[items.currency_name+'_'+items.legal_name]" :data-name='items.currency_name+"/"+items.legal_name'  v-for="(items,index) in  quotation4" :key="index"  v-if="items.is_display == 1&& index<6">
                   <th>&nbsp;</th>
                   <td>{{items.currency_name}}/{{items.legal_name}}</td>
                   <td>{{items.currency_name}}</td>
                   <td class="now_price">{{(items.now_price - 0).toFixed(4)}}</td>
                   <td class="baifen">{{Number(items.change).toFixed(2)|| '0.00'}}%</td>
                   <td class="max">0</td>
                   <td class="min">0</td>
                   <td class="volume1">{{(items.volume-0).toFixed(4)}}</td>
                </tr>
               </tbody>
            </table>
        </div>

         <div class="container1">
           <div class="area">
             <div class="head_gl">{{$t('NEW.l13')}}</div>
             <div style="padding:10px 10px;">
               <table>
                <thead>
                 <tr>
                    <th>{{$t('NEW.s1')}}</th>
                    <th>{{$t('NEW.s2')}}</th>
                   <th>{{$t('NEW.s3')}}</th>
                   <th>{{$t('NEW.s4')}}</th>
                 </tr>
                  </thead> 
                 <tbody >
                     <tr v-for="(items,index) in buy " :key="index" v-if="index<4">
                   <td>{{items.data[0].ts | cutDate }}</td>
                   <td>{{items.data[0].amount |tofixedFour}}</td>
                   <td style="color:#26b947">{{items.data[0].price | tofixedFour}}</td>
                   <td>{{items.symbol}} </td>
                   </tr>
               </tbody>
               
             </table>
             </div>
           </div>
           <div class="area">
             <div class="head_gl">{{$t('NEW.l36')}}</div>
             <div style="padding:10px 10px;">
               <table>
                <thead>
                 <tr>
                    <th>{{$t('NEW.s5')}}</th>
                    <th>Invest</th>
                   <th>{{$t('NEW.s6')}}</th>
                   <th>ROI(%)</th>
                   <th>{{$t('NEW.s7')}}</th>
                 </tr>
                  </thead> 
                 <tbody>
                   <tr >
                   <td>E335917526</td>
                   <td>$12.0700</td>
                   <td style="color:#26b947;">$8.3800</td>
                   <td style="color:#26b947;">69.4100</td>
                   <td>NPXS/BTC</td>
                </tr>
                <tr >
                   <td>E695991924</td>
                   <td>$6.1800</td>
                   <td style="color:#26b947;">$2.5700</td>
                   <td style="color:#26b947;">41.6600</td>
                   <td>NPXS/BTC</td>
                </tr>
                <tr >
                   <td>E169643244</td>
                   <td>$43.3500</td>
                   <td style="color:#26b947;">$2.8900</td>
                   <td style="color:#26b947;">6.6700</td>
                   <td>ETHBEAR/USDT</td>
                </tr>
                <tr >
                   <td>E225902076</td>
                   <td>$132.4400</td>
                   <td style="color:#26b947;">$6.3500</td>
                   <td style="color:#26b947;" >69.4100</td>
                   <td>REP/UQC</td>
                </tr>
               </tbody>
               
             </table>
             </div>
           </div>
           <div class="area">
             <div class="head_gl">{{$t('NEW.l37')}}</div>
             <div style="padding:10px 10px;">
               <table>
                <thead>
                 <tr>
                    <th>{{$t('NEW.s8')}}</th>
                    <th>{{$t('NEW.s9')}}</th>
                   <th>{{$t('NEW.s10')}}</th>
                   <th>{{$t('NEW.s11')}}</th>
                 </tr>
                  </thead> 
                 <tbody>
                   <tr v-for="(items,index) in sell " :key="index" v-if="index<4">
                   <td>{{items.data[0].ts | cutDate}}</td>
                   <td>{{items.data[0].amount |tofixedFour}}</td>
                   <td style="color:#dc3545">{{items.data[0].price|tofixedFour}}</td>
                   <td>{{items.symbol}} </td>
                </tr>
               </tbody>
               
             </table>
             </div>
           </div>
           <div class="area">
             <div class="head_gl" style="color:#c71585">{{$t('NEW.l14')}}</div>
             <div style="padding:10px 10px;">
               <table>
                <thead>
                 <tr>
                    <th>{{$t('NEW.s11')}}</th>
                    <th>{{$t('NEW.s12')}}</th>
                   <th>{{$t('NEW.s13')}}</th>
                 </tr>
                  </thead> 
                 <tbody >
                   <tr v-for="(items,index) in qushi " :key="index" v-if="index<4" >
                   <td>{{items.currency_name}}/{{items.legal_name}}</td>
                   <td :class="[items.change>0?'blueC':'redC']">{{items.change||0}}%</td>
                   <td>{{(items.now_price - 0).toFixed(4)}}</td>
                </tr>
               </tbody>
               
             </table>
             </div>
           </div>
        </div>
      </div>
     <div class="midBanner" v-if="userId == null">
        <div class="contant">
            <h1>{{$t('NEW.l15')}} </h1>
            <div class="butList">
                <router-link class="links" :to="{ name: 'login'}"> <div class="btnR">{{$t('NEW.l16')}}</div></router-link>
               <router-link :to="{ name: 'register'}">  <div class="btnL">{{$t('NEW.l18')}}</div></router-link>
              
            </div>
        </div>
     </div>
     <div class="footer">
        <div class="container2">
            <div class="top">
                <div  class="top1">
                <div class="logoTOp" >
                    <img src="@/assets/images/logo.png" class="navbar-logo" style="margin-right:5px">
                    <div>| {{$t('NEW.l19')}}</div>
                </div>
                <p>{{$t('NEW.l20')}}</p>
                <img class="logo2" src="@/assets/images/footer_img.png" alt="">
                </div>
                <div class="listText">
                   <h1>{{$t('NEW.l21')}}</h1>
                   <ul>
                     <li  @click="goDetail(items.id)"  v-for="(items,index) in footSecond2" :key="index">{{items.title}}</li>
                   </ul>
                </div>
                <div class="listText">
                   <h1>{{$t('NEW.l28')}}</h1>
                   <ul>
                      <li  @click="goDetail(items.id)" v-for="(items,index) in footSecond3" :key="index">{{items.title}}</li>
                   </ul>
                </div>
                <div class="server">
                    <h1>{{$t('NEW.l33')}}</h1>
                    <p>{{$t('NEW.l34')}}</p>
                    <p>{{$t('NEW.l35')}}</p>
                    <ul>
                      <li>
                        <a href="https://t.me/omgfinofficial">
                          <img src="@/assets/images/icon.png" alt="">
                        </a>
                      </li>
                      <li>
                        <a href="https://www.facebook.com/omgfinofficial">
                          <img src="@/assets/images/icon2.png" alt="">
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/omgfin">
                          <img src="@/assets/images/icon3.png" alt="">
                        </a>
                      </li>
                      <li>
                        <a href="https://medium.com/@omgfin">
                          <img src="@/assets/images/icon4.png" alt="">
                        </a>
                      </li>
                    </ul>
                    <img src="@/assets/images/footer_img1.png" alt="">
                </div>
            </div>
            <div class="bottom1">
              <div>
                        

Copyright © 2018 OMGFIN. All rights reserved.                        OMGFIN Limited registered with the registration number 14556327, under the Laws of the Republic of Estonia. Licensed and regulated by the Financial Intelligence Unit under license number FVR000604 for providing services of exchanging a virtual currency against a fiat currency and FRK000513 for providing a virtual currency wallet service.
                    </div>
                    <div>
                      
                        Disclaimer: Bitcoin and digital asset prices are volatile and fluctuate day-to-day. Trading digital assets may be considered a high-risk activity. Proper diligence and sound judgement should be used in evaluating the risks associated with these activities. We do not solicit nor make any representation that digital assets are an investment vehicle. The decision to trade digital assets rests entirely on the users own independent judgement.
                    
                    </div>
                    <!-- <div style=" text-align: right;">
                      {{getTime}}
                    </div> -->
            </div>
        </div>
     </div>
        <!-- <div class="swiper-container banner_wrap swiper-container-horizontal">
            <div class="swiper-wrapper">
              <div class="swiper-slide sliders" v-for="(item,index) in swiperImgs">
                  <a @click="goDetail(item.id)">
                    <img :src="item.cover" />
                  </a>
              </div> -->
               <!-- <div class="swiper-slide sliders">
                   <a href="">
                   <img src="../../static/imgs/bg001.jpg" />
                   </a>
               </div>
               <div class="swiper-slide sliders">
                   <a href="">
                   <img src="../../static/imgs/bg002.jpg" />
                   </a>
               </div>
               <div class="swiper-slide sliders">
                   <a href="">
                   <img src="../../static/imgs/bg003.jpg" />
                   </a>
               </div> -->
            <!-- </div>
             <div class="swiper-pagination swiper-pagination02"></div>
        </div> -->
       
    </div>
</template>


<script>
// import "@/assets/style/iconfont2.css";
// import "@/assets/style/iconfont.css";
import "@/assets/style/index.css";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import indexHeader from "@/view/indexHeader";
import { Carousel, Slide } from 'vue-carousel';
// var echarts = require("echarts");
export default {
  name: "homeContent",
  components: { indexHeader,Carousel,
    Slide },
  data() {
    return {
      quotation: [],
      nowCoin: "",
      //   banner_imgs:[
      //       {href:'',img:'../assets/images/bg2.png'},
      //       {href:'',img:'../assets/images/bg2.png'},
      //       {href:'',img:'../assets/images/bg2.png'}
      //   ],
      curSwiper: 0,
      curCoinTab: 0,
      coinTabList: [{ title: "USDT行情" }, { title: "BTC行情" }],
      coinKlineList: [],
      coinKline: {},
      swiperList: [],
      coinList: [],
      coin_list: [],
      noticeList: [],
      swiperImgs: [],
      footFrist:[],
      footSecond:[],
      haccount:'',
      tableIndex:0,
      quotation4:null,
      quotation2:null,
      quotation3:null,
      gettime:'',//当前时间
      footSecond3:'',
      footSecond2:'',
      userId:null,
      buy:[],
      sell:[],
      qushi:[],
    };
  },
  created() {
    // this.init(this.initKline);
    this.getQuotation();
     this.currentTime(); 
     this.complete()
     this.userId= localStorage.getItem("user_id")

     



  },
  destroyed () {
    // window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll)
    this.getSwiper();
    this.connect();
    this.getNews();
    this.aboutUs();
    this.help();
    this.help2();
    // this.getData()
    var list = setInterval(()=>{
        this.$http({
        url: "/api/currency/quotation_new",
        method: "get"
      }).then(res => {
        if (res.data.type == "ok" && res.data.message.length != 0) {
          var data = res.data.message;
          var arr3=data.find((item) => item.name == 'USDT').quotation;
          var wxCode = arr3[Math.floor(Math.random() * arr3.length)]
           this.qushi.unshift(wxCode);
            if(this.qushi.length>10){
              this.qushi.splice(0,this.sell.length-5);
            }
        }
      });
    },1000)
  },
  filters:{
    tofixed: function(val) {
      val = Number(val);
      return val.toFixed(2);
    },
    tofixedFour: function(val) {
      val = Number(val);
      return val.toFixed(4);
    },
    tofixed8: function(val) {
      val = Number(val);
      return val.toFixed(8);
    },
    cutDate(v){
      return v.substr(-8)
    }
  },
  methods: {
     timestampToTime(timestamp) {
        var time=''
        if(timestamp.toString().length>11){
          time=timestamp
        }else{
          time=timestamp*1000
        }
        var date = new Date(time); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() > 10 ? date.getDate() + ' ' : ('0' + date.getDate()) + ' ';
        var h = date.getHours() > 10 ? date.getHours() + ':' : ('0' + date.getHours()) + ':';
        var m = date.getMinutes() > 10 ? date.getMinutes() + ':' : ('0' + date.getMinutes()) + ':';
        var s = date.getSeconds() > 10 ? date.getSeconds() : ('0' + date.getSeconds());
        return Y + M + D + h + m + s;
    },
     complete() {
       var that = this
      this.$socket.on("match_trade", function(msg) {
        if (msg.type == "match_trade") {
          // console.log(msg,111111111);
          // console.log(msg.data[0].ts)
          var times = that.timestampToTime(msg.data[0].ts)
           msg.data[0].ts= that.timestampToTime(msg.data[0].ts)
          if(msg.data[0].direction == "sell"){
            that.sell.unshift(msg);
            if(that.sell.length>10){
              that.sell.splice(0,that.sell.length-5);
            }
          }
          if(msg.data[0].direction == "buy"){
            that.buy.unshift(msg);
            if(that.buy.length>10){
              that.buy.splice(0,that.buy.length-5);
            }
          }
          // if(that.legal_id ==  msg.legal_id && that.currency_id == msg.currency_id){
          //   var times = that.timestampToTime(msg.data[0].ts)
          //   var way;
          //   msg.data[0].direction == 'buy' ? way=1 : way=2;
          //   var data ={
          //     price: msg.data[0].price,
          //     time: times,
          //     number: msg.data[0].amount,
          //     way: way
          //   }
          //   that.deList.unshift(data)
          //   if(that.deList.length >20){
          //     that.deList.pop()
          //   }
          //   // console.log(that.deList)
          // }

        }
      });
    },
    getTime:function(){
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth()+1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
      _this.gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
    },
    currentTime(){
      setInterval(this.getTime,500)
    },
    // handleScroll () {
    //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //   var top = $('.feature_list').offset().top

    //   console.log(top+'/'+scrollTop)
    // },
    changeTable(index){
      this.tableIndex = index;
    },
    linkDownload (url) {
      window.open(url,'_blank') // 新窗口打开外链接
    },
    register(){
      this.$router.push({name:'register',query: { haccount: this.haccount}})
    },
    getSwiper() {
      this.$http({
        url: "/api/news/list",
        method: "post",
        data:{
          c_id:5
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.type == "ok") {
            this.swiperImgs = res.data.message.list;
            // updated.owl.carousel
          }
        })
        .then(() => {
          // $(".carousel").owlCarousel({
          //            items : 1,
          //            lazyLoad : false,
          //            autoPlay : true,
          //            navigation : false,
          //            navigationText :  false,
          //            pagination : false,
          //         });
          // var mySwiper02 = new Swiper(".banner_wrap", {
          //   // direction: 'vertical',
          //   loop: true,
          //   autoplay: 5000,
          //   // 如果需要分页器
          //   pagination: ".swiper-pagination02",
          //   paginationClickable: true,
          //   autoplayDisableOnInteraction: false,
          //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
          //   observeParents: true //修改swiper的父元素时，自动初始化swiper
          // });
        });
    },
    connect() {
      var that = this;
      that.$socket.emit("login", localStorage.getItem("user_id"));
      that.$socket.on("daymarket", msg => {
        if (msg.type == 'daymarket') {
         
          var cname = msg.symbol.replace("/","_");;
          var change = msg.change;
          var now_price = msg.now_price;
          var volume = msg.volume;
         $('.'+cname).find(".now_price").html((now_price -0).toFixed(4));//最后成交价
         $('.'+cname).find(".volume1").html((volume-0).toFixed(4));//24小时成交量
         $('.'+cname).find(".baifen").html(change+'%');//24小时成交量
         $('.'+cname).find(".max").html((msg.high-0).toFixed(4)|| 0 );//24小时成交量
          $('.'+cname).find(".min").html((msg.low-0).toFixed(4)|| 0);//24小时成交量
          $("div[data-name='" + cname + "']")
            .find(".now_cny")
            .html((now_price *6.9641).toFixed(4)+' CNY');
          if(change<0){
             $('.'+cname).find(".baifen").addClass('redC');
          }else{
            $('.'+cname).find(".baifen").addClass('buleC');
          }
           
        }
      });
    },
    setPercent(a, b) {
      if (a - b == 0) {
        return "0%";
      } else if (a == 0) {
        return "-100%";
      } else if (b == 0) {
        return "+100%";
      } else {
        var p = ((a - b) / b / 100).toFixed(2);
        if (p > 0) {
          p = "+" + p + "%";
        } else {
          p = p + "%";
        }
        return p;
      }
    },
    getQuotation() {
      this.$http({
        url: "/api/currency/quotation_new",
        method: "get"
      }).then(res => {
        if (res.data.type == "ok" && res.data.message.length != 0) {
          // this.nowCoin = this.quotation[0].name;
          var data = res.data.message;
          // console.log(data,111111)
          this.quotation=data.find((item) => item.name == 'USDT').quotation;
          let arr=data.find((item) => item.name == 'USDT').quotation;
          let arr1=[],arr2=[],arr3=[];
          arr.forEach((list,index) => {
            if(list.category_text == '主流区'){
              arr1.push(list);
            }
            if(list.category_text == '创新区'){
              arr2.push(list);
            }
            if(list.category_text == 'DEFI區'){
              arr3.push(list);
            }
          });
          this.quotation2=arr1
          this.quotation3=arr2;
          this.quotation4=arr3;
        }
      });
    },
      // 获取数据
    // getData(){
    //   var that = this;
    //   this.axios.get('/api/currency/quotation_new',{
    //   }).then(res=>{
    //     var arr = [];
    //     for(var i=0;i<msg.length;i++){
    //       arr[i] = msg[i].quotation
    //     };
    //     that.marketList = arr; 
    //     console.log(arr,"hihihi")
    //   })
    //   .catch(function(err){
    //       if(err.response) {
    //         console.log(err.response)
    //       }
    //   })
    // },
    getCurrent(index) {
      this.curCoinTab = index;
    },
    mouseEnter(index) {
      this.curSwiper = index;
    },
    init(callback) {
      this.$http.post("/api/" + "quotation").then(res => {
        if (res.data.type == "ok") {
          this.coinList = res.data.message.coin_list;
          this.swiperList = res.data.message.coin_list;
          callback && callback();
        } else {
          // layer.msg(res.message);
        }
      });
    },

    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      let Y = date.getFullYear() + "/";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "/";
      let D = date.getDate() + " ";
      return Y + M + D;
    },
    // 公告
    getNews() {
      var that = this;
      this.$http.post("http://www.omgfin.pro/api/news/list",{"c_id":4}).then(res => {
        if (res.data.type == "ok") {
          var list = res.data.message.list;
          that.noticeList = list;
        } else {
        }
      });
      // this.$http({
      //   url: "/api/news/list?c_id=5",
      //   type:'post'
      // }).then(res => {
      //   console.log(res);
      //   if (res.data.type == "ok") {
      //     var list = res.data.message.list;
      //     if (list.length > 2) {
      //       that.noticeList = list.slice(0, 2);
      //     } else {
      //       that.noticeList = list;
      //     }
      //   }
      // });
    },
    // 公告详情
    goDetail(id) {
      var id = id;
      this.$router.push({
        name: "noticeDetail",
        query: { id: id }
      });
      // let routeUrl = this.$router.resolve({
      //   name: "noticeDetail",
      //   query: { id: id }
      // });
      // window.open(routeUrl .href, '_blank');
    },
    aboutUs(){
      var that = this;
      this.$http.post("/api/news/list",{"c_id":29}).then(res => {
        if (res.data.type == "ok") {
             var list = res.data.message.list;
             if (list.length > 2) {
            that.footFrist = list;
          } else {
            that.footFrist = list;
          }
        } else {
          // layer.msg(res.message);
        }
      });
    },
    help(){
      var that = this;
      this.$http.post("/api/news/list",{"c_id":30}).then(res => {
        if (res.data.type == "ok") {
             var list = res.data.message.list;
             if (list.length > 2) {
            that.footSecond = list;
          } else {
            that.footSecond = list;
          }
        } else {
          // layer.msg(res.message);
        }
      });
    },
     help2(){
      var that = this;
      this.$http.post("/api/news/list",{"c_id":29}).then(res => {
        if (res.data.type == "ok") {
             var list = res.data.message.list;
            //  console.log(list,"00000")
             if (list.length > 2) {
            that.footSecond2= list;
          } else {
           that.footSecond2= list;
          }
        } else {
          // layer.msg(res.message);
        }
      });
      this.$http.post("/api/news/list",{"c_id":30}).then(res => {
        if (res.data.type == "ok") {
             var list = res.data.message.list;
            //  console.log(list,"00000")
             if (list.length > 2) {
            that.footSecond3= list;
          } else {
           that.footSecond3= list;
          }
        } else {
          // layer.msg(res.message);
        }
      });
    }
  }
};
</script>
<style lang='scss'>
.logo3{
  // display: flex;
  // align-items: center;
  img{
    width: 20px;
  height: 20px;
  position: relative;
  top:5px;
  margin-right: 3px;
  }
}
.redC{
  color: #f74d49;
}
.buleC{
  color: #007bff;
}
#sw{
  .Dcontianer{
    width: 100%;
    height: 600px;
    background-image: url(../assets/images/bk12.png);
    background-size: cover;
    padding-top: 60px;
    box-sizing: border-box;
    .bannerText{
      margin-top: 50px;
      text-align: center;
      color: #fff;
      h1{
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 15px;
       
      }
       p{
        font-size: 20px;
        margin-bottom: 20px;
        }
        div{
         display:flex;
         justify-content: center;
          span{
            padding: 5px 10px;
            background-color: #fff;
            color: #212529;
            border-radius: 40px;
          }
        }
    }
    .swiperContainer{
      width: 1110px;
      margin: 0 auto;
      margin-top: 60px;
      .carousel{
        .active{
          border-bottom: none!important;
        }
         .carouselImg{
            width: 210px;
            height: 109px;
            border-radius: 7px;
            overflow: hidden;
           img{
             width: 100%;
             object-fit: cover;
           }
          }
      }

    }
    .gonggao{
      width: 1110px;
      margin:  0 auto;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      margin-top: 50px;
      .VueCarousel-pagination{
        display: none;
      }
      .VueCarousel-navigation-button{
        display: none;
      }
      .icon5{
        width: 30px;
        height: 30px;
      }
      .right{
        display: flex;
        color: #fff;
        font-size: 13px;
        margin-left: 82px;
        margin-right: 50px;
        width: 100%;
        flex-wrap: nowrap;
    overflow-x: auto;
        div{
          // max-width: 300px;
        }
        p{
          color: #afafaf;
              padding: 0 15px 0 0;
        }
        .sun{
          margin-right: 50px;
          flex-shrink: 0;
          h1{
            display: flex;
            justify-content: space-between;
          }
        }
      }

    }
  }
  .container{
    padding: 48px 0;
    background-color: #F0F0F0;
  }
  .transaction{
    width: 1110px;
    background-color: #fff;
   padding: 15px 15px;
    border-radius: 10px;
    box-sizing: border-box;
    margin: 0 auto;
    .top{
    background: #fff;
    padding: 5px 0;
    box-shadow: 0 3px 10px 0 rgba(0,0,0,.1);
    border-left: 4px solid #2356ac;
    display: flex;
    margin-bottom: 16px;
    }
    .type{
    padding: 3px 3px 3px 3px;
    margin: 0 5px;
    border-radius: 100px!important;
    overflow: hidden;
    color: #333;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img{
      width: 28px;
      height: 28px;
    }
    .cnTitle{
      margin: 0 12px;
    }
    }
    .titleActive{
      background-color: #2356ac;
      color: #fff;
    }
    .transactionTable{
      width: 100%;
      color: #212529;
      tr{
        box-shadow: 0 2px 28px rgba(0,0,0,.1)
      }
      th{
        padding:12px 4px;
        font-size: 12px;
      }
      td{
        font-size: 12px;
      }
      thead{
        box-shadow: 0 3px 10px 0 rgba(0,0,0,.1);
        margin-bottom: 3px;
        th{
          font-weight: bold;
        }
      }
      tbody{
        tr{
          background-color: #EFF3F6;
        }
        tr:nth-child(even){
          background-color: #FBFBFB;
        }
      }
    }
  }
  .container1{
    width: 1110px;
    margin: 0 auto;
    margin-top: 48px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .area{
      width: 49%;
      // min-height: 50px;
      background-color: #fff;
      color: #333;
      margin-bottom: 20px;
      .head_gl{
        background: #fff;
    padding: 8px 8px;
    box-shadow: 0 3px 10px 0 rgba(0,0,0,.1);
    border-left: 4px solid #2356ac;
    font-size: 20px;
    color: #2356ac;
    font-weight: 400;
      }
      table{
         width: 100%;
        //  text-align: center;
        font-size: 13px;
        box-sizing: border-box;
        thead{
          th{
font-weight: bold;
          }
          
        }
      }
       tbody{
        tr{
          background-color: #EFF3F6;
          // padding: 10px 0;
          height: 40px;
        }
        tr:nth-child(even){
          background-color: #FBFBFB;
        }
      }
    }
  }
  .midBanner{
    width: 100%;
    padding: 48px 0;
    background: linear-gradient(to right,#033263 0,#245bcf 100%);
    .contant{
      h1{
      font-size: 25px;
      font-weight: 300;
      margin-bottom: 20px;
      color: #fff;
      text-align: center;
      }
    }
    .butList{
      display: flex;
      justify-content: center;
      .btnR,.btnL{
      padding: 3px 25px;
      font-weight: 300;
       border: 1px solid;
      }
      .btnR{
        background-color: transparent;
        background-image: none;
       border-color: #fff;
      }
      .btnL{
        background: #2356ac;
    border-color: #2356ac;
    margin-left: 5px;
      }
    }
  }
  .footer{
    background-color: #030f27;
    .container2{
      width: 1110px;
      margin: 0 auto;
      padding: 48px 0;
      .top{
        display: flex;
        justify-content: space-between;
        .listText{
        color: #fff;
        h1{
          font-size: 15px;
          margin-bottom: 8px;
        }
            ul{
            li{
              color: #bcc0cc;
              font-size: 13px;
              margin:  5px 0;
            }
          }
      }
      .server{
        h1{
          margin-bottom: 8px;
        }
        img{
          width: 150px;
          height: 64.5px;
        }
        ul{
          display: flex;
          margin-top: 20px;
          // margin-bottom: 20px;
          li{
            img{
              width: 15px;
              height: 15px;
              object-fit: cover;
              margin-left: 5px;
            }
          }
        }
      }
      
      }
      .logoTOp{
        display: flex;
        align-items: center;
        font-size: 15px;
        img{
          width: 110px;
          height: 27px;

        }
       
      
      }
     
      .logo2{
        width: 200px;
        height: 69px;
      }
      .bottom1{
        margin-top: 48px;
        div{
          font-size: 13px;
    color: #858b9a;
    font-family: gothambook;
    margin-top: 8px;
        }
      }
      .top1{
          p{
        margin: 15px 0;
        font-size: 13px;
    color: #bcc0cc;
      }
      }
    }
  }
.topusdt{
  border-top: 1px solid rgba(29,50,66,.7);
  background-color: #0a151e;
  // background-color:#203f46;
  color: #9eb5ca;
  ul{
    width: 100%;
    li{
      width: 20%;
      padding: 14px 0;
      height:120px;
      >div{
        border-right: 1px solid rgba(29,50,66,.7);
        padding: 0 40px;
      }
      .color47{
        color: #477a90;
      }
      .ml5{
        margin-left: 5px;
      }
      button{
        border: none;
        padding: 5px 20px;
        border-radius: 5px;
        height: 30px;
        background: #0d2f32;
        color: #0d8551;
      }
      .downcolor{
        color: #ef4034;
        background: #3b2128;
      }
    }
    li:last-child{
      >div{
        border-right-color: transparent;
      }
    }
    li:hover{
      background: #122331;
      >div{
        border-color: transparent;
      }
    }
    
  }
}
footer{
  width: 100%;
  // background: #111114;
  background: #000;
  padding: 50px 0 0 0;
  text-align: center;
  .content{
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    border-top: 1px solid #42f1eb;
    padding-top: 30px;
    dl{
      width:33%;
      text-align: center;
      dt{
        width:100%;
        font-size: 16px;
        color: #fff;
        margin-bottom: 10px;
        // text-align: left;
      }
      dd{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #a7b7c7;
        line-height: 24px;
        // text-align: left;
        cursor: pointer;
        padding-top: 10px;
        &:hover{
          color: #fff;
        }
      }
    }
  }
  p{
    border-top: 1px solid #303035;
    height: 70px;
    color: #727b92;
  }
}
.concat_ul{
  justify-content: flex-end;
  li{
    width: 32px;
    height: 32px;
    background: #303e63;
    border-radius: 50%;
    margin-right: 10px;
    img{
      width: 20px;
      height: 20px;
      margin-top: 6px;
    }
  }
  li:hover{
    background: #5697f4;
  }
  .wechat-box{
    position: relative;
    .weimg{
      width: 140px;
      height: 140px;
      position: absolute;
      top: -155px;
      left: -60px;
      border: 5px solid #fff;
      display: none;
    }
  }
  .wechat-box:hover .weimg{
      display: block;
  }
}
.md {
  width: 1500px;
  margin: 0 auto;
  > div:first-child {
    margin-top: 90px;
    text-align: center;
    font-size: 40px;
    color: #fff;
    > span:last-child {
      margin-left: 6px;
      color: #33fffb;
    }
    .btn {
      background: linear-gradient(90deg, #33fffb, #44c3d5);
      width: 268px;
      margin: 30px auto 0;
      text-align: center;
      line-height: 56px;
      border-radius: 30px;
      font-size: 18px;
      color: #fff;
    }
    img {
      display: block;
      margin: 0 auto;
      width: 1180px;
      height: 635px;
    }
  }
  > div:nth-child(2) {
    padding-top: 60px;
    background: url("../assets/images/zg.jpg")
      right top/ 832px 432px no-repeat;
    height: 500px;
    > div:first-child {
      font-size: 40px;
      font-weight: bold;
      color: #bec1da;
    }
    > div:nth-child(2) {
      margin-top: 20px;
      color: rgba(139, 137, 200, 0.5);
      line-height: 30px;
      width: 45%;
    }
  }
}
.news {
  margin-top: 100px;
  position: relative;
  > p {
    font-weight: 600;
    font-size: 20px;
    margin: 200px auto 100px;
    color: #fff;
    width: 1500px;
  }
  .line {
    position: absolute;
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.05);
    top: 105px;
    z-index: 9;
  }
  > .items {
    width: 1500px;

    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    > .item {
      transition: all 0.3s;
      height: 330px;
      cursor: pointer;
      color: hsla(0, 0%, 100%, 0.9);
      border-radius: 4px;
      width: 33%;
      > .date {
        font-size: 24px;
        padding-bottom: 60px;
        color: #bec1da;
      }
      > p {
        color: #8b89c8;
      }
      .content {
        position: relative;
        transition: all 0.3s;
        max-width: 485px;
        height: 206px;
        padding: 30px;
        border-radius: 6px;
        background-color: rgba(24, 24, 76, 1);
        background-size: 100% !important;
        &::before {
          content: "";
          position: absolute;
          left: 50px;
          top: -10px;
          width: 0;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
          border-bottom: 10px solid #2b2b6d;
          opacity: 0;
          -webkit-transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }
        img {
          position: absolute;
          border-radius: 6px;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: all 0.5s;
          // z-index: -1;
        }
        .title {
          font-size: 16px;
          color: #bec1da;
          padding-bottom: 30px;
        }
        p {
          font-size: 14px;
          color: #8b89c8;
        }
      }
      > .title {
        font-size: 16px;
        color: #bec1da;
        // font-weight:
      }
      &:hover {
        transition: all 0.5s;

        .content {
           &::before{
             opacity: 1;
           }
          > p,
          > div {
            transform: translateY(16px);
            transition: all 0.5s;
          }
          img {
            transition: all 0.5s;
            opacity: 1;
          }
          // background: rgba(24, 24, 76, 0) url("../assets/images/homehov.jpg");
          // background-size: 100%;
        }
      }
    }
    > .item:nth-child(3) {
      opacity: 1;

      .content {
        &::before{
          opacity: 1;
        }
        div,
        p {
          position: relative;
          z-index: 99;
        }
        img {
          opacity: 1;
        }
      }
    }
  }
}
.notice {
  width: 1500px;
  margin: 0 auto;
  justify-content: space-between;
  > div {
    border-radius: 3px;
    font-size: 12px;
    padding: 30px;
    width: 360px;
    height: 360px;
    color: rgba(139, 137, 200, 0.5);
    background: linear-gradient(to bottom right, #2b2b6d, #18184c);
    cursor: pointer;
    box-shadow: none;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);

    > div:nth-child(2) {
      transition: all 0.3s;
    }
    div:nth-child(3) {
      padding-top: 10px;
    }
    &:hover {
      background: url("../assets/images/homehov.jpg") center center/ 100% 100%
        no-repeat;
      box-shadow: 0 0.05rem 0.45rem rgba(0, 0, 0, 0.2);
      transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      color: #fff;
      > div:nth-child(2) {
        transform: translateY(-10px);
        transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      }
      > div:nth-child(3) {
        border-top: 1px solid rgba(139, 137, 200, 0.5);
      }
      .notpic1 {
        background-image: url("../assets/images/hhov2.png") !important;
      }
      .notpic2 {
        background-image: url("../assets/images/hhov4.png") !important;
      }
      .notpic3 {
        background-image: url("../assets/images/hhov5.png") !important;
      }
      .notpic4 {
        background-image: url("../assets/images/hhov8.png") !important;
      }
    }
    > div:first-child {
      width: 80px;
      height: 88.8px;
      margin: 30px auto 0;
      margin-bottom: 20px;
      text-align: center;
    }
    > div:nth-child(2) {
      font-size: 18px;
      margin: 30px 0 20px;
      color: #bec1da;
    }
    > div:last-child {
      line-height: 24px;
    }
  }
  > div:first-child {
    > div:first-child {
      background: url("../assets/images/hhov1.png") center center/ 100% 100%
        no-repeat;
    }
  }
  > div:nth-child(2) {
    > div:first-child {
      background: url("../assets/images/hhov3.png") center center/ 100% 100%
        no-repeat;
    }
  }
  > div:nth-child(3) {
    > div:first-child {
      background: url("../assets/images/hhov6.png") center center/ 100% 100%
        no-repeat;
    }
  }
  > div:nth-child(4) {
    > div:first-child {
      background: url("../assets/images/hhov7.png") center center/ 100% 100%
        no-repeat;
    }
  }
}
.mb {
  position: relative;
  // margin-top: 100px;
  height: 800px;
  padding-left: 800px;
  img {
    position: absolute;
    left: -497px;
    top: 0;
    width: 1770px;
  }
  > div {
    display: flex;
    position: relative;
    z-index: 99;
    height: 800px;
    justify-content: center;
    flex-direction: column;
    > div {
      padding: 100px 0 30px;
      font-size: 36px;
      color: #33fffb;
    }
    p {
      line-height: 30px;
      color: rgba(139, 137, 200, 0.5);
    }
  }
}
.home-box {
  // background: rgb(24, 24, 76);
}
.swiper-container {
  min-height: 300px;
}
div.swiper-container .swiper-pagination {
  // left: initial;
  // right: 10px !important;
  // top: 0;
  // height: 100%;
  // width: 10px;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
}
div.swiper-container .swiper-pagination > span {
  // display: block;
  background: #fff;
  border-radius: 0;
  width: 56px;
  height: 3px;
  // opacity: 0.5;
  // margin: 10px 0;
}
div.swiper-container .swiper-pagination-bullet-active {
  background: transparent;
  border: 2px solid #fff;
}
.up-clr {
  color: #12b886;
}
.down-clr {
  color: #cc4951;
}
/* 币种列表 */
.coins-list {
  margin: 10px auto;
  width: 1500px;
  line-height: 40px;
  text-align: center;
  // border: 1px solid #4e5b85;
  .coin-tab {
    height: 42px;
    color: #c7cce6;
    display: flex;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    > ul {
      display: flex;
      li {
        padding: 0 40px;
        font-size: 14px;
        // box-shadow: 0 0 1px hsla(231, 9%, 54%, 0.2);
        // border-bottom: 1px solid #4e5b85;
        // border-right: 1px solid #4e5b85;
      }
      .activeCoin {
        border-bottom: none;
      }
    }
  }
  .list-title {
    display: flex;
    > span {
      flex: 1;

      text-align: center;
      color: #8b89c8;
      font-size: 14px;
    }
  }
  .list-con {
    // background: rgb(32, 36, 55);
    max-height: 680px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    li:nth-child(2n) {
      background: rgb(24, 24, 76);
    }
    li:nth-child(2n + 1) {
      background: rgb(34, 31, 97);
    }
    li {
      display: flex;
      // border-bottom: 1px solid #282e44;
      color: #c7cce6;
      &:hover {
        background: rgb(22, 22, 68);
      }
      > div {
        flex: 1;
      }
    }
  }
}
.carousel .swiper-slide:hover {
  background-color: #327add;
}
.nav_left,
.con_left {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.withdraw {
  margin: 0 4px;
}
.carousel .last a:hover {
  cursor: pointer;
}
.sliders {
  width: 100%;
  max-height: 540px;
  overflow: hidden;
  img{width: 100%;display: block;}
  @media screen and (max-width:1560px){
    // height: 465px;
    // img{
    //   width: 100%;
    //   height: 465px;
    // }
  }
}
@media screen and (max-width:1410px){
  // .mt{margin-top:5px;}
}
.swiper-container-horizontal>.swiper-pagination-bullets{
  bottom: 25px;
}
.swiper-pagination-bullet{
  width: 56px!important;
  height: 3px;
  border-radius: 0;
  background: #fff;
}

.notice_ul {
  margin: 0 40px;
  padding: 5px 0;
  // background: #171c2b;
  overflow: hidden;
  word-break: keep-all;
}
.notice_ul > li {
  // flex: 1;
  font-size: 12px;
  padding: 0 15px;
  text-align: center;
  color: #9eb5ca;
  word-break: keep-all;
  position: relative;
}
.notice_ul > li::after {
  content: "/";
  position: absolute;
  left: -0.5em;
  color: #9eb5ca;
}
.notice_ul > li:last-child:after {
  content: "";
  color: #6b80ae;
}
.notice_ul > li:hover {
  color: #6b80ae;
  cursor: pointer;
}
.feature_wrap {
  background-color: #fff;
  padding: 90px 0;
  text-align: center;
  color: #54748f;
  line-height: 2em;
}
.feature_wrap h2 {
  font-size: 28px;
  margin-bottom: 10px;
  color: #192544;
}
.feature_wrap .feature_list {
  padding-top: 80px;
  width: 70%;
  margin: 0 auto;
}
.feature_wrap .feature_list li {
  float: left;
  width: 33%;
  background: transparent none no-repeat top;
  // padding-top: 140px;
  padding-top: 70px;
}
.feature_wrap .feature_list li.feature_safe {
  // background-image: url(../../static/imgs/feature_safe.8e76904.svg);
  background-image: url(../../static/imgs/ppp0.svg)
}
.feature_wrap .feature_list li.feature_eco {
  // background-image: url(../../static/imgs/feature_eco.4f174e6.svg);
  background-image: url(../../static/imgs/ppp1.svg)

}
.feature_wrap .feature_list li.feature_user {
  // background-image: url(../../static/imgs/feature_user.7002f27.svg);
  background-image: url(../../static/imgs/ppp2.svg)

}
.feature_wrap h3 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #192544;
}
.notice_box{
    width: 100%;
    height: 52px;
    border-top: 1px solid rgba(29,50,66,.7);
    margin-top: -1px;
    background-color: #f6f9fc;
    position: relative;
    >div{
      margin: 0 30px;
      font-size: 12px;
      line-height: 52px;
      height: 36px;
      overflow: hidden;
      word-break: keep-all;
      text-align: center;
      span{
        display: inline-block;
        position: relative;
        padding: 0 2em 0 1.5em;
        color: #54748f;
        cursor: pointer;
      }
      span:before {
        content: "/";
        position: absolute;
        left: -.5em;
        color: #54748f;
      }
      span:nth-child(1):before{
        content: "";
      }
      span:hover{
        color: #357ce1;
      }
    }
}
.client_wrap{
  width: 100%;
  height: 710px;
  color: #9eb5ca;
  text-align: center;
  line-height: 2em;
  background-color: #fff;
  .wrap_in{
    height:700px;
    padding-top: 100px;
    // background-color: #152940;
    background: url(../../static/imgs/blue.svg) no-repeat;
    background-size: cover;

    h2{
      margin-bottom: 24px;
      color: #fff;
      font-weight: 400;
      font-size: 28px;
    }
    .nextp{color:#9eb5ca}
    ul{
      width: 810px;
      margin: 0 auto;
      text-align: left;
      justify-content: space-around;
      li{
        margin: 0 15px;
        color: #9eb5ca;
        padding: 40px 0;
        line-height: 48px;
        position: relative;
        cursor: pointer;
        p{
          height: 48px;
          width: 48px;
          margin: 0 10px 0 0;
          vertical-align: top;
          border-radius: 50%;
          background: rgba(53,124,225,.1) none no-repeat 50%;
          background-image: url(../assets/images/p0.svg)
        }
        .p1{
          background-image: url(../assets/images/p1.svg)
        }
        .p2{
          background-image: url(../assets/images/p2.svg)
        }

        .codebox{
          position: absolute;
          left: 15%;
          top: 100px;
          -webkit-transform: translate(-50%);
          -ms-transform: translate(-50%);
          transform: translate(-50%);
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          width: 120px;
          height: 130px;
          border: 1px solid #357ce1;
          border-radius: 2px;
          background: #fff none no-repeat 12px 12px/96px 96px;
          text-align: center;
          color: #357ce1;
          font-size: 12px;
          line-height: 18px;
          z-index: 6;
          display: none;
          img{
            width: 100px;
            height: 100px;
            margin: 0 auto;
            display:block;
            margin-top: 10px;
          }
        }
      }
      li:hover .codebox{
        display: block;
      }
    }
    .mon_mind{
      width: 518px;
      position: relative;
      margin: 0 auto;
      >div{
        width: 100%;
        .pcimg{
          width: 518px;
          margin: 0 auto;
        }
      }
      .mobimg{
        width: 122px;
        position: absolute;
        right: -60px;
        bottom: -20px;
        width: 122px;
        height: 253px;
        background: #0a151e none no-repeat 50%/cover;
        -webkit-box-shadow: -9px 12px 62px 0 rgba(36,52,69,.3);
        box-shadow: -9px 12px 62px 0 rgba(36,52,69,.3);
        border-radius: 16.47px;
      }
    }
  }
}
.register_wrap{
  height: 240px;
  width: 100%;
  // border-top: 1px solid #cad7e0;
  background: #fff;
  h2{
    color: #232a4a;
    font-size: 22px;
    line-height: 24px;
  }
  .rebox{
    margin: 32px auto 0 auto;
  }
  .input-register{
    width: 400px;
    height: 40px;
    font-size: 12px;
    color: #000;
    border: 1px solid #bdced9;
    border-radius: 2px;
    padding-left: 16px;
  }
  button{
    margin-left: 8px;
    display: inline-block;
    height: 40px;
    padding: 0 44px;
    font-size: 16px;
    min-width: 120px;
    -webkit-appearance: none;
    background-color: #357ce1;
    color: #fff;
    border: none;
    outline: none;
    border-radius: 2px;
    cursor: pointer;
  }
  button:hover{
    opacity: .8;
  }
}
}
</style>





// WEBPACK FOOTER //
// src/view/homeContent.vue